import { render } from "./SettingLanguage.vue?vue&type=template&id=1b075797&scoped=true&ts=true"
import script from "./SettingLanguage.vue?vue&type=script&lang=ts"
export * from "./SettingLanguage.vue?vue&type=script&lang=ts"

import "./SettingLanguage.vue?vue&type=style&index=0&id=1b075797&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b075797"]])

export default __exports__